import { ReactNode } from "react";

type ContainerProps = {
  children: ReactNode;
  className?: string;
  size?: "default" | "narrow";
};

export default function Container({ children, className = "", size = "default" }: ContainerProps) {
  const width = size === "narrow" ? "max-w-[820px]" : "max-w-content";
  return <div className={`mx-auto w-full ${width} px-4 md:px-6 ${className}`}>{children}</div>;
}